import { render } from "./QRCode.vue?vue&type=template&id=4183aa10"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ANPHUVIET\\ebanking-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__